<template>
  <div class="col-md-3 mb-sm-3 mb-md-0">
    <!-- <b-button variant="success" block size="lg" squared @click="redirectMedidas">
			<i class="mdi mdi-database-cog-outline mdi-18px"></i>
			Serviços/Intervenções
		</b-button> -->

    <b-list-group role="tablist" class="shadow bg-white h-100 p-b rounded-0">
      <b-list-group-item
        @click="
          page = 'medidas';
          $emit('page', page);
        "
        :class="page == 'medidas' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Detalhes da Medidas Socioeducativa
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'vunerabildiade';
          $emit('page', page);
        "
        :class="page == 'vunerabildiade' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Vulnerabilidades e Violação de Direitos
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'objetivo';
          $emit('page', page);
        "
        :class="page == 'objetivo' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Objetivos / Metas
      </b-list-group-item>
      <b-list-group-item
        v-if="item.acomp_creas == 1"
        @click="
          page = 'mensal';
          $emit('page', page);
        "
        :class="page == 'mensal' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Acompanhamento Mensal
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'avaliacao';
          $emit('page', page);
        "
        :class="page == 'avaliacao' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Avaliação Final
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'termo';
          $emit('page', page);
        "
        :class="page == 'termo' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Termo de Compromisso
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'aterior';
          $emit('page', page);
        "
        :class="page == 'aterior' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Acompanhamento Anterior
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'pia';
          $emit('page', page);
        "
        :class="page == 'pia' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        PIA
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'historicopia';
          $emit('page', page);
        "
        :class="page == 'historicopia' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Histórico PIA
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<script>
  export default {
    props: ["active", "item"],
    data() {
      return { page: "medidas" };
    },
    mounted() {
      if (this.active) {
        this.page = this.active;
      }
    },
    methods: {
      redirectMedidas() {
        this.$router.push({
          path: `/dashboard/medidas/${this.$route.query.familia_id}`,
          query: { familia_id: this.$route.query.familia_id },
        });
      },
    },
  };
</script>
